import React, {Component} from 'react';
import {NavBar,} from 'antd-mobile';
import "./style.less";
import {connect} from "react-redux";
const succeed = require('../../../common/image/succeed.png');
@connect(
    state => ({userInfo: state.userInfo})
)
export default class PayFinish extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    perfectionInfo=()=>{
        console.log(this.props);
        this.props.history.push(`/perfectionInfo/${this.props.match.params.id}`)
    };
    render(){
        return(
            <div className="payFinish">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.push('/pay/home')}/>}
                >支付完成</NavBar>
                <div className="warp">
                    <div className="box">
                        <img src={succeed}/>
                        <p>订单支付完成</p>
                    </div>
                    {
                        this.props.location.state.specialPage == 0 ? (
                            <div className="btn">
                                <button onClick={this.perfectionInfo}>去完善身份信息  >></button>
                            </div>
                        ):null
                    }
                    <p>温馨提示：根据交通管理需求，上车前请携带身份证</p>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Home/PayFinish/index.js